import { Navbar } from "@/components/Navbar";
import HeroSection from "@/components/home/HeroSection";
import ProblemSection from "@/components/home/ProblemSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import CaseStudiesSection from "@/components/home/CaseStudiesSection";
import IndustriesSection from "@/components/home/IndustriesSection";

import CTASection from "@/components/home/CTASection";
import { Footer } from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="pt-16">
        <HeroSection />
        <ProblemSection />
        <HowItWorksSection />
        <CaseStudiesSection />
        <IndustriesSection />
        
        <CTASection />
      </div>
      <Footer />
    </div>
  );
};

export default Index;
